<template>

	<!-- .conference-switch -->
	<div class="mb-5" v-if='show'>
		<div class="vx-col flex mb-5">
			<h5 class="mr-2">{{ $t('VedioConference') }}</h5>
			<vs-switch v-model="switch_conference">
        <span slot="on">On</span>
        <span slot="off">Off</span>
			</vs-switch>
		</div>

		<!-- class="conference" style="display:none" -->
		<template v-if='switch_conference'>
				<!-- v-show="iframe_link || showChatDiv == 'trueIframe'" -->
			<!-- <div> -->
					<!-- v-show="showIframeDiv" -->
			<template v-if='iframe_link'>
				<img v-if='pip' class='w-full' :src="imagePath" alt="voting" />

				<div ref="meet" :class="{'float-right h-48 absolute pip inline': pip, 'container home-card': !pip}" class="text-center">
					<iframe
						ref='iframe'
						:class="{'responsive-iframe': !pip}"
						allow="microphone; camera"
						frameborder="0"
            :src='iframe_link'
					></iframe>

					<div class="vx-row" id="mic">
						
							<span class="list ml-2 cursor-pointer">
								<vx-tooltip :text="$t('BlockUnmuteNoteText')">
									<feather-icon
										icon="MicOffIcon"
										svgClasses="w-7 h-7"
										class="disabledIcon"
									/>
								</vx-tooltip>
							</span>
							
							<span class="list ml-8 cursor-pointer">
								<vx-tooltip :text="$t('BlockUnmuteNoteText')">
									<feather-icon
										icon="VideoOffIcon"
										svgClasses="w-7 h-7 hover:text-danger stroke-current"
										class='disabledIcon'
									/>
								</vx-tooltip>
							</span>
					</div>
				</div>
			</template>

			<!-- Here navigation icon-controls -->
			<!-- Here Chat DIV -->

			<!-- </div> -->
				<!-- v-show="!iframe_link && showChatDiv != 'trueIframe'"  -->
			<div v-if="!iframe_link && !isSpeakerOrAdmin" class="no-conference-link container home-card" style="text-align: center">{{ $t('ConferenceLink') }}</div>
			<br/>
		</template>

		<!-- id="external-conference" style="display: none;" -->
		<div class="vx-col w-full mb-5" v-if='!switch_conference'>
			<a v-if='event_detail' :href="event_detail.external_conference_link" target="_blank">{{ $t('VideoConference1') }}</a>
		</div>

		<!-- id="meet-container" -->
		<div style='max-height: 610px; height: 600px;' v-if='isBNE'>
			<img class='inline' style='width: 100%;' v-if='pip' :src="imagePath" alt="">
			<div ref="meet" :class="{'float-right h-48 absolute pip inline': pip, 'relative': !pip}" class="text-center">
				<!-- <div ref="meet">
				</div> -->

        <template v-if='bne_activated'>
          <div class="custom-floating-div" v-if="audioDeviceStatus" style="left:212px; width: 328px;">
            <div class="audio-preview-content">
              <div v-if="audioInput.length > 0" class="audio-preview-header">
                <feather-icon icon="MicIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  />
                  <span class="device-title">
                    Microphones
                  </span>
              </div>
              <div :class="{'audio-preview-entry--selected': currentDevice.audioInput && currentDevice.audioInput.deviceId == obj.deviceId}" @click="setAudioInputDevice(obj.label, obj.deviceId)" class="audio-preview-header device-header cursor-pointer" v-for="(obj) in audioInput" :key="obj.label">
                <feather-icon v-if="currentDevice.audioInput && currentDevice.audioInput.deviceId == obj.deviceId"
                    icon="CheckCircleIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  />
                  <span class="device-title">
                  {{obj.label}}
                  </span>
              </div>
              <div v-if="audioOutput.length > 0" class="audio-preview-header">
                  <feather-icon icon="Volume2Icon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  />
                <span class="device-title">
                Speakers
                </span>
              </div>
              <div :class="{'audio-preview-entry--selected': currentDevice.audioInput && currentDevice.audioOutput.deviceId == obj.deviceId}" @click="setAudioOutputDevice(obj.label, obj.deviceId)" class="audio-preview-header device-header cursor-pointer" v-for="(obj) in audioOutput" :key="obj.deviceId">
                <feather-icon v-if="currentDevice.audioOutput && currentDevice.audioOutput.deviceId == obj.deviceId"
                    icon="CheckCircleIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  />
                  <span class="device-title">
                {{obj.label}}
                </span>
              </div>
            </div>
          </div>
          <div class="custom-floating-div" v-if="videoDeviceStatus" style="left:345px; width: 328px;">
            <div class="audio-preview-content">
              <div v-if="videoInput.length > 0" class="audio-preview-header">
                <feather-icon icon="CameraIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  />
                  <span class="device-title">
                    Camera
                  </span>
              </div>
              <div :class="{'audio-preview-entry--selected': currentDevice.videoInput && currentDevice.videoInput.deviceId == obj.deviceId}" @click="setVideoInputDevice(obj.label, obj.deviceId)" class="audio-preview-header device-header cursor-pointer" v-for="(obj) in videoInput" :key="obj.deviceId">
                <feather-icon v-if="currentDevice.videoInput && currentDevice.videoInput.deviceId == obj.deviceId"
                    icon="CheckCircleIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  />
                  <span class="device-title">
                  {{obj.label}}
                  </span>
              </div>
            </div>
          </div>
          <div class="vx-row" id="mic">
            <span class="list ml-2 cursor-pointer" v-if="!audio">
              <vx-tooltip :text="$t(!block_unmute ? 'Mute' : 'BlockUnmuteNoteText')">
                <feather-icon
                  icon="MicIcon"
                  svgClasses="w-7 h-7"
                  @click="muteAudio()"
                  :class="{disabledIcon: block_unmute, 'hover:text-danger stroke-current': !block_unmute }"
                />
              </vx-tooltip>
            </span>
            <span class="list ml-2 cursor-pointer" v-else>
              <vx-tooltip :text="$t(!block_unmute ? 'Unmute' : 'BlockUnmuteNoteText')">
                <feather-icon
                  icon="MicOffIcon"
                  svgClasses="w-7 h-7"
                  @click="muteAudio()"
                  :class="{disabledIcon: block_unmute, 'hover:text-danger stroke-current': !block_unmute }"
                />
              </vx-tooltip>
            </span>
            <span class="chevronDownIcon cursor-pointer">
                <feather-icon
                  :class="{'disabledIcon': block_unmute && audioInput.length == 0 && audioOutput.length == 0}"
                  icon="ChevronDownIcon"
                  svgClasses="w-4 h-4 hover:text-danger stroke-current"
                  @click="setAudioDeviceStatus()"
                />
            </span>
            <span class="list ml-8 cursor-pointer" v-if="!video">
              <vx-tooltip text="On">
                <feather-icon
                  icon="VideoIcon"
                  svgClasses="w-7 h-7 hover:text-danger stroke-current"
                  @click="muteVideo()"
                />
              </vx-tooltip>
            </span>
            <span class="list ml-8 cursor-pointer" v-else>
              <vx-tooltip text="Off">
                <feather-icon
                  icon="VideoOffIcon"
                  svgClasses="w-7 h-7 hover:text-danger stroke-current"
                  @click="muteVideo()"
                />
              </vx-tooltip>
            </span>
            <span class="chevronDownIcon video-chevronDownIcon cursor-pointer">
              <feather-icon
                :class="{'disabledIcon': videoInput.length == 0}"
                icon="ChevronDownIcon"
                svgClasses="w-4 h-4 hover:text-danger stroke-current"
                @click="setVideoDeviceStatus()"
              />
            </span>
          </div>
        </template>
			</div>
		</div>
	</div>
</template>
<script>
	import { mapGetters } from 'vuex';
	import { environment } from '../../../src/environment';

	export default {
		name: 'EventConference',
		data() {
			return {
				audioInput: [],
				audioOutput: [],
				videoInput: [],
				audio: true,
				video: true,
				audioDeviceStatus: false,
				videoDeviceStatus: false,
				switch_conference: true,
				pip: false,
				currentDevice: null,
        		userInfo: null,
				imagePath: ""
			}
		},
		computed: {
			...mapGetters([
				"event_listener",
				'event_detail',
				'myself',
				'isAdmin',
				'isModeratorOrAdmin',
				'isSpeaker',
				'isModerator',
				'participants',
				'isHandRaised'
			]),
			streaming_status() {
				return this.event_detail.is_streaming_started;
			},
			api() { return this.$store.state.event.bne_api },
			bne_activated() { return this.$store.state.event.bne_activated },
			block_unmute() {
				if(this.myself.user_role == 'admin' || this.myself.user_role == 'admin_observer')
					return false;
				const participant = this.participants.find(p => p.user_id == this.myself.id);
				return participant ? participant.block_unmute : true;
			},
      isBNE() {
        return this.switch_conference && this.iframe_link == null
      },
			isSpeakerOrAdmin() {
				return this.isSpeaker || (this.myself && (this.myself.user_role=='admin' || this.myself.user_role=='admin_observer'));
			},
			show() {
				const event = this.event_detail;
				return event && (event.status == 1 || (event.status == 3 && (this.isSpeaker || this.isModeratorOrAdmin)))
			},
			iframe_link() {
				if(this.event_detail == null || (this.isSpeakerOrAdmin && this.event_detail.is_bne_room == 1))
					return null;
				let link = this.isSpeakerOrAdmin ? this.event_detail.speaker_link : this.event_detail.conference_link;

				if(link != '' && link != null){
					link = link.replace("%FULL_NAME%", encodeURI(this.$options.filters.displayName(this.myself)));
					link = link.replace("%EMAIL%", encodeURI(this.$options.filters.displayEmail(this.myself)));
				}
				return link ? link : null;
			}
		},
		watch: {
			streaming_status: function() {
				this.iframeUpdate();
			},
			iframe_link: function() {
				this.iframeUpdate();
			},
			event_listener: function(listen) {
				switch(listen.key) {
					case 'EventVotingStatusChanged':
						setTimeout(function () { this.pipMode(listen.payload) }.bind(this), 3000)
						break;
					case 'EventMuteUnmute': 
						if(listen.payload.executeMuteAudio && listen.payload.user_id==this.myself.id)
							this.muteAudio(false, true);
						break;
					default: break;
				}
			},
			// isHandRaised() {
			// 	if(this.api)
			// 		this.api.executeCommand('toggleRaiseHand');
			// },
			switch_conference(value) {
        this.switch_conferenza(value && this.show);
			},
			isSpeaker(now) {
        	if (!now)
					  this.disposeBNEApi();
        	this.switch_conferenza(this.switch_conference && this.show);
			},
			show(value) {
				if (!value)
					this.disposeBNEApi();
				this.switch_conferenza(this.switch_conference && value);
			},
			pip(value) {
				const el = this.$refs['meet'];
				const iframe = el ? el.getElementsByTagName('iframe')[0] : null;
				if(iframe) {
					if(value) {
						iframe.style.height = '';
						iframe.style.width = '';
					}else {
						iframe.style.height = '600px';
						iframe.style.width = '100%';
					}

				} 
			}
		},
		mounted(){
      this.userInfo = {
				email: this.myself.email,
				displayName:
				this.myself.first_name +
				" " +
				this.myself.last_name,
			};
      this.switch_conferenza(this.switch_conference && this.show);
		},
		beforeDestroy() {
			this.disposeBNEApi();
		},
		methods: {
			iframeUpdate() {
        const vm = this;
        console.log('iframUpdate')
        this.$nextTick(function() {
          // THIS IS DONE, BECAUSE THERE IS NO OTHER WAY TO RELOAD FRAME, SO TOUCHING SRC WILL AUTO RELOAD IFRAME
          console.log(vm.iframe_link, vm.$refs.iframe)
          if(!(vm.$refs.iframe && vm.iframe_link))
            return false;
          const el = vm.$refs.iframe;
          const link = vm.iframe_link;
          el.src = '';
          setTimeout(function() {
            console.log(link);
            el.src = link;
            el.src+=''; // force reload
          },1000);
        })
        
			},
			disposeBNEApi() {
				this.$store.commit('REMOVE_BNE_API');
			},
			pipMode(data) {
				if(data.overlayer_url) {
					this.imagePath = environment.baseDomain + data.overlayer_url;
					this.pip = true;
				}else
					this.pip = false;
			},
			activateSpeakerBneRoom() {
				if(this.api)
					return false;

				const el = this.$refs.meet;
				const options = {
					roomName: 'concilium-'+this.event_detail.conference_key,
					parentNode: el,
					height: 600,
					userInfo: this.userInfo,
					interfaceConfigOverwrite: {
					DISABLE_JOIN_LEAVE_NOTIFICATIONS:true,
					DISABLE_PRESENCE_STATUS: true,
					DISABLE_RINGING: true,
					HIDE_INVITE_MORE_HEADER: true,
					TOOLBAR_BUTTONS: [
						'desktop', 'fodeviceselection', 'profile', 'recording',
						'livestreaming', 'settings',
						'videoquality', 'filmstrip',
						'tileview', 'mute-everyone','sharedvideo'
					]
					},

				};

						
				const storageKey = `event:${this.event_detail.id}:mute_preference`
				let isMuted = {audio:false, video:false};
				if(this.$store.getters.isAdmin) {
					if(sessionStorage.getItem(storageKey))
						isMuted = JSON.parse(sessionStorage.getItem(storageKey));
					else
						sessionStorage.setItem(storageKey, JSON.stringify(isMuted));
				}else{
					const participant = this.participants.find(p => p.user_id==this.myself.id);
					if(participant) {
						isMuted = {audio:participant.is_muted, video:participant.is_video_muted}
					}
				}
				
				const api = new JitsiMeetExternalAPI("concilium.bnesim.com", options);
				this.$store.commit('SET_BNE_API', api);

				// current status
				api.isAudioMuted()
				.then(muted => {
					if(Boolean(isMuted.audio) != Boolean(muted))
						this.muteAudio();
				});
				api.isVideoMuted()
				.then(muted => {
					if(Boolean(isMuted.video) != Boolean(muted))
						this.muteVideo();
				});
				api.getAvailableDevices().then(devices => {
					this.device = devices;
					this.audioInput = devices.audioInput.filter(audioInput => audioInput.label != '');
					this.audioOutput = devices.audioOutput.filter(audioOutput => audioOutput.label != '');
					this.videoInput = devices.videoInput.filter(videoInput => videoInput.label != '');
				});

				// on change events
        api.on('videoConferenceJoined', res => {
          this.$store.commit('SET_BNE_ACTIVATED', true);
        });
				api.on("audioMuteStatusChanged", (res) => {
					if(sessionStorage.getItem(storageKey)){ 
						const pref = JSON.parse(sessionStorage.getItem(storageKey));
						pref.audio = res.muted;
						sessionStorage.setItem(storageKey, JSON.stringify(pref));
					}
					this.audio = res.muted;
				});
				api.on("videoMuteStatusChanged", (res) => {
					this.video = res.muted;
					if(sessionStorage.getItem(storageKey)){ 
						const pref = JSON.parse(sessionStorage.getItem(storageKey));
						pref.video = res.muted;
						sessionStorage.setItem(storageKey, JSON.stringify(pref));
					}else
						this.updateMuteStatus();
				});
				
				api.executeCommand('subject', this.event_detail.event_name);
				// if(this.isHandRaised)
					// this.api.executeCommand('toggleRaiseHand');
				
				this.getCurrentDevices();
			},
			switch_conferenza(isOn) {
				if(this.isSpeakerOrAdmin && this.event_detail.is_bne_room == 1) {
				// alert(isOn);
					this.disposeBNEApi();
					if(!isOn) 
						return false;
					this.$nextTick(() => {
						this.activateSpeakerBneRoom();
					});
				}
			},
			muteAudio(update=true, force = false) {
				if(this.block_unmute && !force)
					return false; // block this feature		
      			this.api.executeCommand("toggleAudio");
				this.audio = !this.audio;
				if(update && !this.isAdmin)
					this.updateMuteStatus();
			},
			muteVideo() {
				this.api.executeCommand("toggleVideo");
			},
			updateMuteStatus(){
				const req = {
					user_id: this.myself.id,
					is_muted: this.audio,
					is_video_muted: this.video,
					event_id: this.event_detail.id,
					is_save: false
				};
				this.$store.dispatch("updateMuteStatus", req)
			},
			setAudioInputDevice(deviceLabel, deviceId){
				let data = this.api.setAudioInputDevice(deviceLabel, deviceId);
				this.getCurrentDevices('audioInput', deviceId);
			},

			setAudioOutputDevice(deviceLabel, deviceId){
				this.api.setAudioOutputDevice(deviceLabel, deviceId);
				// this.getCurrentDevices();
				this.getCurrentDevices('audioOutput', deviceId);
			},

			setVideoInputDevice(deviceLabel, deviceId){
				this.api.setVideoInputDevice(deviceLabel, deviceId);
				this.getCurrentDevices('videoInput', deviceId);
			},
			async getCurrentDevices(type = "", deviceId =""){
				this.currentDevice = await this.api.getCurrentDevices();
				if(type == 'audioInput')
					this.currentDevice.audioInput.deviceId = deviceId;
				else if(type == 'audioOutput')
					this.currentDevice.audioOutput.deviceId = deviceId;
				else if(type== 'videoInput')
					this.currentDevice.videoInput.deviceId = deviceId;
			},

			setAudioDeviceStatus(){
				if(this.block_unmute)
					return false; // blocks device status
				this.audioDeviceStatus = !this.audioDeviceStatus;
				this.videoDeviceStatus = false;
				this.getCurrentDevices();
			},
			setVideoDeviceStatus(){
				this.videoDeviceStatus = !this.videoDeviceStatus;
				this.audioDeviceStatus = false;
				this.getCurrentDevices();
			},
		}
	}
</script>
<style lang="scss" scoped>
	/* start by luca */
	.container {
		position: relative;
		overflow: hidden;
		width: 100%;
		padding-top: unset;
		border-radius: 5px;
	}

	@media only screen and (max-width: 992px) {
		.conference .home-card {
			height: 600px;
		}
	}

	@media (min-width: 576px) {
		.container {
			max-width: unset;
			height: 600px;
		}
	}

	.device-title {
		padding-left: 10px;
		text-align: left;
	}

	.device-header{
		padding-left: 35px;
	}
	.device-header:hover{
		background: #3f4e5e;
	}
	
	#mic {
		position: absolute;
		bottom: 30px;
		left: 0;
		right: 0;
		margin-left: auto;
		margin-right: auto;
		width: 140px;
	}
	#mic .feather-icon, #mic .feather-icon:hover {
		background: #fff;
		padding: 10px;
		border-radius: 50%;
	}

	#mic .feather-icon:not(.disabledIcon), #mic .feather-icon:not(.disabledIcon):hover {
    	color: #7367F0 !important;
	}

	.chevronDownIcon .feather-icon, .chevronDownIcon .feather-icon:hover {
		padding: 2px !important;
		border: solid 1px #ddd;
	}
	.chevronDownIcon {
		position: absolute;
		left: 40px;
		top: 22px;
	}
	.video-chevronDownIcon{
		left: 112px !important;
	}
	/* #mic .feather:hover{
		color: #7367F0 !important;
	} */
	.audio-preview-entry--selected .feather-icon {
    color: #008000;
	}
	.audio-preview-entry--selected .feather-check-circle:hover {
			color: #008000 !important;
	}
	.audio-preview-header .feather-volume-2, .audio-preview-header .feather-mic, .audio-preview-header .feather-camera{
		color: #ffffff !important;
	}
	.audio-preview-entry--selected {
			background: #1c2025;
			margin-left: 0;
			padding-left: 21px;
			padding-left: 16px !important;
	}
	.audio-preview-header {
			color: #fff;
			display: flex;
			padding: 16px;
	}
	.audio-preview-content{
		background: #2a3a4b;
		font-size: 15px;
		line-height: 24px;
		max-height: 456px;
		overflow: auto;
	}
	.responsive-iframe {
		/* position: absolute; */
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		width: 100%;
		height: 100%;
		max-height: 600px;
		max-width: unset;
	}
	.custom-floating-div{
		left: 0 !important;
		/* width:auto !important; */
		max-width: 350px !important;
	}
	.custom-floating-div{
		position: absolute;
		bottom:80px;
		left: 0;
		right: 0;
		margin-left: auto;
		margin-right: auto;
	}

	.disabledIcon {
		color: gray !important;
	}

	.pip {
		z-index: 1;
		margin-top: 35%;
		right: 4%;
	}

	@media only screen and (max-width: 767px) {
		.custom-floating-div{
			left: 0 !important;
			width:auto !important;
			max-width: 300px !important;
		}
		.custom-floating-div{
			position: fixed;
			bottom:80px;
			left: 0;
			right: 0;
			margin-left: auto;
			margin-right: auto;
		}
	}

</style>
